import { render, staticRenderFns } from "./holidayActFemaleMain.vue?vue&type=template&id=395d072c&scoped=true"
import script from "./holidayActFemaleMain.vue?vue&type=script&lang=js"
export * from "./holidayActFemaleMain.vue?vue&type=script&lang=js"
import style0 from "./holidayActFemaleMain.vue?vue&type=style&index=0&id=395d072c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395d072c",
  null
  
)

export default component.exports